





























































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { Modal } from '@/components/general'
import { AdvanceControlTableList, AdvanceControlFormCreateEdit, FiltersAdvanceControl as Filters } from '@/components/dailyControl'

// services
import { AdvanceControlService } from '@/services/dailyControl'

// models
import { Paginator } from '@/models'
import { AdvanceControl, AdvanceControlForm, FiltersAdvanceControl } from '@/models/dailyControl'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const advanceControlDefault: AdvanceControlForm = {
  employee_id: null,
  advance_type_id: null,
  register_date: null,
  discount_date: null,
  amount: 0,
  observations: ''
}

export default defineComponent({
  name: 'AdvanceControlIndex',
  components: {
    PageHeader,
    AdvanceControlTableList,
    Modal,
    AdvanceControlFormCreateEdit,
    ButtonExport,
    AccordionFilters,
    Filters
  },
  setup () {
    const showModal = ref(false)
    const title = 'Control de Adelantos'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Control de Adelanto'
      }
      return 'Crear Control de Adelanto'
    })
    const items = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Control de Adelantos',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const filters: Ref<FiltersAdvanceControl> = ref({
      registerDate: null,
      applyDate: null,
      employee: null,
      advanceType: null
    })
    const advanceControl: Ref<AdvanceControlForm> = ref(advanceControlDefault)
    const allAdvanceControl: Ref<AdvanceControl[]> = ref([])
    const getAdvanceControlWithPagination = async () => {
      loading('show')
      const res = await AdvanceControlService.getWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      pagination.value = res.pagination
      allAdvanceControl.value = res.objects
      loading('hide')
    }
    getAdvanceControlWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      advanceControl.value = {
        ...advanceControlDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      advanceControl.value = {
        ...advanceControlDefault
      }
      idEdit.value = null
      getAdvanceControlWithPagination()
    }
    const editItem = (item: AdvanceControl) => {
      advanceControl.value = {
        employee_id: item.employee_id,
        advance_type_id: item.advance_type_id,
        register_date: item.register_date,
        discount_date: item.discount_date,
        amount: item.amount,
        observations: item.observations
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: AdvanceControl) => {
      const msg = `Seguro que desea eliminar el Adelanto del Empleado: ${item.employee.fullName}, con fecha de: ${item.register_date}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await AdvanceControlService.delete(item.id)
        alerts.success()
        getAdvanceControlWithPagination()
      }
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getAdvanceControlWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getAdvanceControlWithPagination()
    }

    const headersExcel = [
      { text: 'Fecha de Registro', value: 'register_date' },
      { text: 'Fecha de Descuento', value: 'discount_date' },
      { text: 'Empleado', value: 'employee' },
      { text: 'Importe', value: 'amount' },
      { text: 'Tipo de Adelanto', value: 'advanceType' }
    ]

    const itemsExcel = computed(() => {
      return allAdvanceControl.value.map(item => {
        return {
          ...item,
          advanceType: item.advanceType.name,
          employee: getFullNameFormat(item.employee)
        }
      })
    })

    const getAllitems = async () => {
      allAdvanceControl.value = await AdvanceControlService.getAll(filters.value)
    }

    const getByFilters = () => {
      pagination.value.currentPage = 1
      getAdvanceControlWithPagination()
    }

    const clearFilters = () => {
      pagination.value.currentPage = 1
      filters.value = {
        registerDate: null,
        applyDate: null,
        employee: null,
        advanceType: null
      }
      getAdvanceControlWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      advanceControl,
      saveSuccess,
      allAdvanceControl,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      headersExcel,
      itemsExcel,
      getAllitems,
      filters,
      getByFilters,
      clearFilters
    }
  }
})
